(function (j, global) {

  // Селекторы для объектов Aspose.
  var asposeSelectors = {
    comments: 'div[id^=_cmnt]',
    commentAnchors: 'a[href^=#_cmnt]',
    commentArea: 'a[name^=_cmntref]'
  };

  // Селекторы для объектов.
  var wordDocumentSelector = {
    comments: '.msocomtxt',
    commentAnchors: '.msocomanchor',
    commentArea: '.comment-area',
    insertedText: 'ins',
    deletedText: 'del'
  };

  /**
  * Иницииализация предпросмотра.
  */
  $(window).load(function () {
    // У мобильной версии есть свои нюансы работы.
    if (WAforPDA()) {
      $("#previewTools").on("click", function () {
        $("#toolsBox").toggle();
      });

      var url = new WA.URL();

      if (url.getParam('Parent').toLowerCase() === 'explorer' && url.getParam('view').toLowerCase() === 'preview') setFullScreenInPda();
      $("#fullScreenToogle").parent().insertAfter("#versionSelect");

      // Делаем чтобы выбор версии работал и в мобильном ВД
      $("#versionSelect select").on("change", function () {
        jQuery.npocomputer.modules.previewdoc.selectVersion($(this).val());

        autoResizeFrame("#contentContainer");
      });

      // Чтобы выбор масштаба работал в мобильном ВД
      $(".set-scale select").on("change", function () {
        var scale = $(this).val();
        jQuery.npocomputer.modules.previewdoc.setScale(scale);
        WA.SRV.session.setPreviewScale(scale);
        autoResizeFrame("#contentContainer");
      });


      // Тогда, когда excel документ полностью загружен, надо его отмасштабировать
      if (isExcelDocument(getObjectDataType())) {
        $("#contentContainer").load(function () {
          getjSheetFrame().ready(function () {
            $('#contentContainer').css({ "min-width": getSheetSize()[0] + "px", "min-height": getSheetSize()[1] + "px" });
          });
        });
      };

      // Пагинатору надо бы быть пониже.
      $("#paginator").insertAfter("#toolsBox");
    };
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Смена масштаба при выборе значения в pick реквизите
  */
  global.onPickChangeScale = function (scale) {
    jQuery.npocomputer.modules.previewdoc.setScale(scale);
    WA.SRV.session.setPreviewScale(scale);
  };


  /**
  * При нажатии на кнопку во весь экран, прячем картчку, показываем доп-тулбар.
  * @function setFullScreenInPda
  */
  function setFullScreenInPda() {
    $(".ribbon, .ViewName, .header, #toolsBox").toggle();
    $("#fullScreenToogle")
      .toggleClass("Pda/fullSize.png")
      .toggleClass("Pda/originalSize.png");
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Проверка того, что данный документ - excel документ
  * @return {boolean}
  * @function isExcelDocument
  */
  function isExcelDocument(extension) {
    var exts = ['XLS', 'XLSX', 'ODS'];
    return _.indexOf(exts, extension) > -1;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
* Проверка того, что данный документ - word документ
* @return {boolean}
* @function isWordDocument
*/
  function isWordDocument(extension) {
    var wordExts = ['DOC', 'DOCX', 'RTF', 'ODT'];

    return _.indexOf(wordExts, extension) > -1;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Получение фрейма с excel таблицей
  */
  function getjSheetFrame() {
    var jMainFrame = $("#contentContainer").contents();
    var jInnerFrame = $(jMainFrame.find('frameset').find('frame[name="frSheet"]')[0].contentDocument);
    return jInnerFrame;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Получить тип объекта.
  */
  function getObjectDataType() {
    var context = j.npocomputer.modules.previewdoc.context || Core.preview.info;
    return context.objectsData[context.selectedObj.id].dataType;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  /**
  * Находимся ли мы в мобильном ВД
  * @function WAforPDA
  * @private
  * @return {boolean}
  */
  var WAforPDA = function () {
    return ($("html.mobile").length > 0);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Получение размера excel таблицы
  * В главном iframe ищется frame с таблицей, а
  * внтри него берутся рамеры непосредственно саммой таблицы и блока со
  * ссылками
  * @inner
  * @function getSheetSize
  * @return {Array}
  */
  var getSheetSize = function () {
    var jBody = getjSheetFrame().find('body');
    var jSheet = jBody.find("table");
    var jFooter = jBody.find("div");
    return [jSheet.width(), jSheet.height() + jFooter.height()];
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Изменение размера iframe под размер содержимого.
  * @global
  * @param {string|object} DOM-элемент или jquery-селектор
  * @function autoResizeFrame
  */
  global.autoResizeFrame = function (elem) {
    if (!WAforPDA()) return;
    var newHeight = $(elem).get(0).contentWindow.document.body.scrollHeight;
    $(elem).css({ "height": newHeight, "overflow": "hidden" });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  if (typeof j.npocomputer === 'undefined') j.npocomputer = {};
  if (typeof j.npocomputer.modules === 'undefined') j.npocomputer.modules = {};

  var isActiveBtn = function (btn) {
    return !btn.hasClass("btn-disabled");
  };

  var isTurnOnBtn = function (btn) {
    return btn.hasClass("selected");
  };

  var disableScreen = function (disable) {
    var context = j.npocomputer.modules.previewdoc.context || Core.preview.info;
    var container = j("#" + context.wrapperId);
    var modal = container.prev('.npocomputer-previewdoc-modal');
    modal
      .height(container.height())
      .width(container.width());
    if (disable) {
      modal.show();
    } else {
      modal.hide();
    }
  };

  /**
  * Смена страницы у документа
  * @function changePage
  */
  var changePage = function (pageNumber, actionFromPage, hadlerParams) {
    var format = "{0}/{1}/{2}/";
    var context = j.npocomputer.modules.previewdoc.context || Core.preview.info;

    if (pageNumber > context.convertedObj.pageCount)
      pageNumber = context.convertedObj.pageCount;

    if (pageNumber < 1)
      pageNumber = 1;

    context.selectedObj.pageNumber = pageNumber;

    var frame = j("#" + context.wrapperId + " #" + context.frameId);

    // Для Excel установим фон, т.к. в его css фон прозрачный, а не белый.
    if (isExcelDocument(getObjectDataType())) {
      frame.css({ 'background-color': '#fff' });
    }

    frame.attr("src", format.replace("{0}", context.previewHandlerUrl).replace("{1}", context.convertedObj.id).replace("{2}", pageNumber) + (hadlerParams != '' ? "?" + hadlerParams : ''))
      .off('load')
      .on('load', function () {
        var contents = frame.contents();

        var styleLink = ('<link rel="stylesheet" href="/css/iframe-preview.css">');
        contents.find('head').append(styleLink);

        if (context.convertedObj.isImage) {
          var img = contents.find('img');
          if (img.attr('initWidth') == null) {
            img.attr('initWidth', img.width());
          }
          if (img.attr('initHeight') == null) {
            img.attr('initHeight', img.height());
          }
          img.addClass('previewImage');
        }

        if (!WAforPDA()) {
          // Если отображается документ Word, то добавить классы для корректного отображения комментариев.
          if (isWordDocument(getObjectDataType())) {
            // Добавить классы к комментариям.
            contents.find(asposeSelectors.comments).addClass('msocomtxt');
            contents.find(asposeSelectors.commentAnchors).addClass('msocomanchor');
            contents.find(asposeSelectors.commentArea).addClass('comment-area');

            // Переместить комментарии в отдельный контейнер.
            var comments = contents.find(wordDocumentSelector.comments);
            if (comments.length > 0) {
              var commentsColumn = j('<div class="comments-container"/>');
              contents.find('body').append(commentsColumn);
              comments.appendTo(commentsColumn);

              // Заменим инициалы в примечаниях на полное имя.
              comments.each(function (index, el) {
                var infoStr = $(el).attr('style');
                if (infoStr) {
                  try {
                    var info = infoStr.split(';');
                    for (var i = 0; i < info.length; i++) {
                      var params = info[i].split(':');
                      if (params[0] === '-aw-comment-author') {
                        $(el).find(wordDocumentSelector.commentAnchors).html(params[1].replaceAll("'", "") + '<br>');
                      }
                    }
                  } catch (e) {
                    // Если не удалось распарсить дополнительную информацию, то ничего не делаем,
                    // в примечании останутся инициалы.
                  }
                }
              });
            }

            // Добавить класс к основному тексту.
            contents.find('body > div')
              .not('.comments-container')
              .each(function (i, el) {
                j(el).addClass('WordSection' + i);
              });
            // HACK: Исправим ссылки в odt. Для ссылок задается тег span с inline-стилями.
            if (getObjectDataType() === 'ODT') {
              contents.find('a')
                .css('text-decoration', 'underline')
                .find('span')
                .css('color', '');
            }
          }

          Core.preview.scrolling.init(context);
          Core.preview.resizeTextDocuments(context);
          Core.preview.fixHttpLinks(context);
        };

        var wrapper = j('#' + context.wrapperId);

        // restore settings for image.
        var scale = wrapper.find('.set-scale');
        var scaleVal;
        if (!WAforPDA()) {
          scaleVal = scale.data('scale') || Core.preview.info.selectedObj.scale;
        } else {
          if ($('.fit-to-width').hasClass('selected')) scaleVal = 'w';
          else if ($('.fit-to-height').hasClass('selected')) scaleVal = 'h';
          else scaleVal = scale.find('input.pickFieldHidden').val();
        };

        frameLoad(frame);
        j.npocomputer.modules.previewdoc.setScale(scaleVal);
        if (!WAforPDA()) {
          Core.preview.scrolling.loadNeighbors(1);
        };

        // #94073
        if (WA.ENV.device && WA.ENV.device.model && WA.ENV.device.model.toLowerCase() === 'ipad') {
          setTimeout(function () { fitTo(context.selectedObj.scale); }, 300);
        } else {
          fitTo(context.selectedObj.scale);
        }
      });

    //Шамов А.: Для мобильной версии можно расширить iframe по его содержимому для включения глобальной прокрутки.
    j('#' + context.wrapperId + ' .page-number-field').val(pageNumber);
  };

  var printDocFromPreview = function () {
    setTimeout(function () {
      var iframeContent = $("#contentContainer").get(0).contentWindow;
      iframeContent.focus();
      iframeContent.print();
    }, 100);
  };

  var setFrameHeight = function (context) {
    var wrapper = j("#" + context.wrapperId);
    var currFrame = wrapper.find('#' + context.frameId);
  };

  var frameLoad = function (frame) {
    var docBody = frame.contents().find('body');
    if (!docBody.length && frame[0].contentWindow.frames["frSheet"] != null) {
      docBody = $(frame[0].contentWindow.frames["frSheet"].document).find('body');
    };

    /**
    * Скрываем раскрытые списки pick реквизитов, при нажатии на фрэйм.
    * @see замечание 76935
    */
    docBody.on("click", function () {
      $('.rs_container').hide();
    });

    docBody.find('a').each(function (index) {
      var _this = $(this);
      var href = _this.attr("href");
      if (href != null && href != '' && !href.match("^#")) { //&& !href.match("^" + curLocation)
        _this.attr("target", "_blank");
      }
    });

    // set frame styles.
    var frameBody = frame.contents().find('body');

    var padding = '0 10px';
    if (frameBody.children('img').length > 0) {
      padding = 0;
      frameBody.addClass('previewImageContainer');
    }
    frameBody.css({ 'margin': 0, 'padding': padding });

    frame.addClass('previewContent_shown');

    if ($.scrollActive || WA.ENV.isAndroid()) {
      if (!WAforPDA()) {
        CreatePreviewScrollForiPad();
        AttachHandlersToTabs();
      };
    }
  };


  var initSelectedVersion = function () {
    var context = j.npocomputer.modules.previewdoc.context;
    if (!context && Core.preview) { context = Core.preview.info; }

    if (!context) return;
    var wrapper = j("#" + context.wrapperId);

    if (WAforPDA()) {
      var wrapper = j("#" + context.wrapperId);
      var jScale = wrapper.find(".set-scale");
      var jScaleInput = jScale.find("select");
      jQuery.npocomputer.modules.previewdoc.setScale(jScaleInput.val());
    };

    if (context.errorMessage == '') {
      changePage(context.selectedObj.pageNumber);
    }

    wrapper.find(".page-count").text("/ " + context.convertedObj.pageCount);

    if (context.convertedObj.pageCount <= 1) {
      wrapper.find(".page-next-btn").parent().hide();
      $("#paginator").hide();
    } else {
      wrapper.find(".page-next-btn").parent().show();
      $("#paginator").show();
    }

    var setScaleIcon = wrapper.find("#scale");
    if (context.convertedObj.isImage) {

      // TODO: disabling allow-copy-text icon
      wrapper.find(".fit-to-width").show();
      wrapper.find(".fit-to-height").show();
      wrapper.find(".fit-to-window").show();
      wrapper.find(".rotate-CW").show();
      wrapper.find(".rotate-CCW").show();
      setScaleIcon.show();
    } else {
      wrapper.find(".fit-to-width").hide();
      wrapper.find(".fit-to-height").hide();
      wrapper.find(".fit-to-window").hide();
      wrapper.find(".rotate-CW").hide();
      wrapper.find(".rotate-CCW").hide();
      setScaleIcon.hide();
    }

    // Кнопки для управления режимом исправления и показа примечаний в Word
    if (isWordDocument(getObjectDataType())) {
      wrapper.find('.enable-change-track').show();
      wrapper.find('.enable-comments').show();
      // Проверяем, не было ли отключено отображение исправлений
      if (!$("div.enable-change-track").hasClass('selected')) {
        var frame = wrapper.find("#" + context.frameId);
        $(frame).load(function () {
          $.npocomputer.modules.previewdoc.disableTrackChanges();
        });
      }
      // Проверяем, не был ли отключен показ примечаний
      if (!$("div.enable-comments").hasClass('selected')) {
        var frame = wrapper.find("#" + context.frameId);
        $(frame).load(function () {
          setTimeout(function () {
            $.npocomputer.modules.previewdoc.disableComments();
          }, 100);
        });
      }
    } else {
      wrapper.find('.enable-change-track').hide();
      wrapper.find('.enable-comments').hide();
    }
  };

  $(window).bind('orientationchange', function (event) {
    initSelectedVersion();
  });


  /**
  * Смена масштаба изображения.
  * На мобильных вместо pick-виджета обычный select
  * @see Замечание №76866
  * @function fitTo
  * @param {string} type ['10','20',...,'100', 'w','h']
  * @global
  */
  var fitTo = function (type) {
    var context = j.npocomputer.modules.previewdoc.context || Core.preview.info;

    ////не меняем масштабы если открыт word-вый документ

    if (!WA.isMobile() && Core.preview.isTextDocument(getObjectDataType())) return;

    var wrapper = j("#" + context.wrapperId);
    var frame = wrapper.find("#" + context.frameId);
    var img = frame.contents().find('img');
    var fitWidth = wrapper.find(".fit-to-width");
    var fitHeight = wrapper.find(".fit-to-height");
    var fitWindow = wrapper.find(".fit-to-window");
    // для айпада подменяем объект фрейма на его обертку, чтобы размеры для картинок считались правильные. потому что фрейм растягивается
    if (!WAforPDA() && WA.ENV.os.name.toLowerCase() == 'ios') {
      frame = $('.iosOverflow');
      frame.height($(window).height() - 160);
    }

    var fitToHeight = function () {
      img.width('auto');
      if (!WAforPDA()) {
        if (img.hasClass('E') || img.hasClass('W')) {
          img.width($(frame).height());
          img.height('auto');
        }
        else img.height('100%');
      } else {
        img.add($(frame)).height($(window).height() - $("iframe").offset().top);
      };

      if ($.scrollActive || WA.ENV.isAndroid()) {
        if (!WAforPDA()) RefreshScrollInIFrame();
      }
    };
    var fitToWidth = function () {
      img.height('auto');
      img.width('100%');
      //почему-то ipad не любит 100%, и иногда игнорит её.
      if ($.ipad) img.width($(".npocomputer-previewdoc").width());

      if ($.scrollActive || WA.ENV.isAndroid()) {
        if (!WAforPDA()) RefreshScrollInIFrame();
      }
    };

    if (type == "h" || type == "w" || type == '100' || type == 'a') {
      context.selectedObj.scale = type;
      var jScale = wrapper.find(".set-scale");
      var jScaleInput = WAforPDA() ? jScale.find("select") : jScale.find("input.pickField");
      if (type == '100') {
        if (!WAforPDA()) {
          jScaleInput.val(type + "%");
        } else {
          jScaleInput.val(type);
        }
      } else {
        if (!WAforPDA()) {
          jScaleInput.val((type == "h") ? context.scaleHeightText : ((type == "w") ? context.scaleWidthText : context.scaleWindowText));
        } else {
          jScaleInput.val(type);
        };
      }
      if (!WAforPDA()) jScaleInput.find("input.pickFieldHidden").val(type);
      else jScale.data("scale", type);
    }

    if (WAforPDA()) {
      var jScale = wrapper.find(".set-scale");
      var jScaleInput = WAforPDA() ? jScale.find("select") : jScale.find("input.pickField");
      jScale.data("scale", type);
    };

    if (type == "h") {
      fitToHeight();

      fitWidth.removeClass("selected");
      fitHeight.addClass("selected");
      fitWindow.removeClass("selected");
    } else if (type == "w") {
      fitToWidth();

      fitWidth.addClass("selected");
      fitHeight.removeClass("selected");
      fitWindow.removeClass("selected");
    } else if (type == 'a') {
      var k = img.height() / img.width();
      var newH = k * img.attr('initWidth');
      if (newH < frame.height()) {
        if (img.parent().hasClass('placeholder')) {
          img
            .height('auto')
            .width('100%');
        } else {
          img
            .height("auto")
            .width(img.attr('initWidth'));
        }
      } else {
        newH = k * frame.width();
        if (newH >= frame.height()) {
          fitToHeight();
        } else {
          fitToWidth();
        }
      }

      fitWidth.removeClass("selected");
      fitHeight.removeClass("selected");
      fitWindow.addClass("selected");
    }
    else {
      fitHeight.removeClass("selected");
      fitWidth.removeClass("selected");
      fitWindow.removeClass("selected");
    }
  };

  j.npocomputer.modules.previewdoc =
  {
    register: function (context) {
      var me = this;
      j.npocomputer.modules.previewdoc.context = context;

      if (context.errorMessage != '') {
        me.showError(context.errorMessage, context.errorType);
      }

      var wrapper = j("#" + context.wrapperId);

      // PAGER FIELD
      var pageNumberField = wrapper.find(".page-number-field");
      pageNumberField.on("keypress", function (event) {

        if (event.which == 13) {

          var newPageNumber = Number(j(this).val());

          if (!WAforPDA()) {
            Core.preview.scrolling.jumpToPage(newPageNumber)
          }
          else {
            changePage(newPageNumber, true);
          }
          event.preventDefault();

        }

        if (String.fromCharCode(event.which).match(/[^0-9]/g)) event.preventDefault();

      });
      pageNumberField.on("blur", function () {

        var newPageNumber = Number(j(this).val());
        if (!WAforPDA()) {
          Core.preview.scrolling.jumpToPage(newPageNumber)
        } else {
          changePage(newPageNumber, true);
        }
      });

      // PAGER PREV BTN
      wrapper.find(".page-prev-btn").on("click", function () {

        var currEl = j(this);
        if (isActiveBtn(currEl)) {

          var currPageNumber = Number(pageNumberField.val());

          if (currPageNumber > 1) {
            currPageNumber--;
            if (!WAforPDA()) {
              Core.preview.scrolling.jumpToPage(currPageNumber)
            } else {
              changePage(currPageNumber, true);
            }
          }

        }

        return false;

      });

      // PAGER NEXT BTN
      wrapper.find(".page-next-btn").on("click", function () {

        var currEl = j(this);
        if (isActiveBtn(currEl)) {
          var currPageNumber = Number(pageNumberField.val());

          if (currPageNumber < context.convertedObj.pageCount) {
            currPageNumber++;

            if (!WAforPDA()) {
              Core.preview.scrolling.jumpToPage(currPageNumber)
            } else {
              changePage(currPageNumber, true);
            };
          };

        };

        return false;

      });


      // FIT TO WIDTH BTN
      wrapper.find(".fit-to-width").on("click", function () {

        var currEl = j(this);
        if (isActiveBtn(currEl)) {

          if (isTurnOnBtn(currEl)) {
            j.npocomputer.modules.previewdoc.setScale("100");
            WA.SRV.session.setPreviewScale("100");
          } else {
            j.npocomputer.modules.previewdoc.setScale("w");
            WA.SRV.session.setPreviewScale("w");
          }

        }

        return false;

      });

      // FIT TO HEIGHT BTN
      wrapper.find(".fit-to-height").on("click", function () {

        var currEl = j(this);
        if (isActiveBtn(currEl)) {

          if (isTurnOnBtn(currEl)) {
            j.npocomputer.modules.previewdoc.setScale("100");
            WA.SRV.session.setPreviewScale("100");
          } else {
            j.npocomputer.modules.previewdoc.setScale("h");
            WA.SRV.session.setPreviewScale("h");
          }

        }

        return false;

      });

      // FIT TO WINDOW BTN
      wrapper.find(".fit-to-window").on("click", function () {
        var currEl = j(this);
        if (isActiveBtn(currEl)) {
          if (isTurnOnBtn(currEl)) {
            j.npocomputer.modules.previewdoc.setScale("100");
            WA.SRV.session.setPreviewScale("100");
          } else {
            j.npocomputer.modules.previewdoc.setScale("a");
            WA.SRV.session.setPreviewScale("a");
          }
        }
        return false;
      });

      // FIT TO ROTATE CW
      wrapper.find(".rotate-CW").on("click", function () {
        if (!WAforPDA()) {
          Core.preview.scrolling.rotateCW();
        } else {
          changePage(context.selectedObj.pageNumber, null, 'Rotate=CW');
        }
        return false;
      });

      // FIT TO ROTATE CCW
      wrapper.find(".rotate-CCW").on("click", function () {
        if (!WAforPDA()) {
          Core.preview.scrolling.rotateCCW();
        } else {
          changePage(context.selectedObj.pageNumber, null, 'Rotate=CCW');
        }
        return false;
      });

      // PRINT FROM PREVIEW
      wrapper.find(".print-from-preview").on("click", function () {
        printDocFromPreview();
        return false;
      });

      // DISABLE CHANGE TRACKING
      wrapper.find(".enable-change-track").on("click", function () {
        me.toggleTrackChanges();
        return false;
      });

      // DISABLE WORD COMMENTS
      wrapper.find(".enable-comments").on("click", function () {
        me.toggleComments();
        return false;
      });

      // CHANGE WINDOW MODE BTN
      wrapper.find(".change-window-mode").on("click", function () {

        var currEl = j(this);
        /**
        * В MoblieWA ничего не открывается, просто сыкрывается верхнаяя панель .
        */
        if (WAforPDA()) {
          setFullScreenInPda();
        } else {
          if (isActiveBtn(currEl)) {
            var url = context.actionUrl;
            var objData = context.objectsData[context.selectedObj.id];

            var concatSymbol = "&";
            if (url.indexOf("?") < 0) concatSymbol = "?";

            if (objData.requestParams != null) {
              for (var i = 0; i < objData.requestParams.length; i++) {
                var param = objData.requestParams[i];
                url = url + concatSymbol + param.Key + "=" + param.Value;
                concatSymbol = "&";
              }
            }

            url = url + concatSymbol + "previewPageNum=" + context.selectedObj.pageNumber + "&previewScale=" + context.selectedObj.scale + "&previewAllowCopyText=" + context.selectedObj.allowCopyText;
            global.location = url;
          }
        }

        return false;
      });

      // Контекстное меню над документом.
      wrapper.find(".document-context-menu").on("click", function (e) {
        var jButton = $(this)
          .attr("id", WA.CR.ID)
          .attr("kind", "edoc")
          .addClass('cannot_delete');

        var jButtonsPanel = jButton.closest('.preview-panel');

        var buttonOffset = jButton.offset();
        var buttonsPanelOffset = jButtonsPanel.offset();
        var buttonsPanelHeight = jButtonsPanel.outerHeight();

        window.Core.contextmenu.show(jButton, {}, { 'left': buttonOffset.left, 'top': buttonsPanelOffset.top + buttonsPanelHeight }, false);
        return false;
      });


      // MODAL
      j('<div class="npocomputer-previewdoc-modal"></div>').insertBefore(wrapper);

      var currFrame = wrapper.find('#' + context.frameId);

      j(currFrame).on('load', function () {
        j.npocomputer.modules.previewdoc.context = context;
        disableScreen(false);

        var frameBody = j(currFrame).contents().find('body');
        if (!frameBody.length && currFrame[0].contentWindow.frames["frSheet"] != null) {
          frameBody = $(currFrame[0].contentWindow.frames["frSheet"].document).find('body');
        }
        var isErrorMsg = false;

        if (frameBody[0].childElementCount == 0) {

          isErrorMsg = true;
          try {
            var errorObj = JSON.parse(frameBody.text());
          } catch (e) {
            // don't parse text, it's meens TXT document.
            isErrorMsg = false;
          }

        }
        if (isErrorMsg) {

          currFrame.hide();
          me.showError(errorObj.error, errorObj.errorType);

        } else {
          if (context.convertedObj.isImage) {

            var img = j(currFrame).contents().find('img');
            if (img.attr('initWidth') == null) {
              img.attr('initWidth', img.width());
            }
            if (img.attr('initHeight') == null) {
              img.attr('initHeight', img.height());
            }

            // restore settings for image.
            var scale = wrapper.find(".set-scale");
            var scaleVal;
            if (WAforPDA()) {
              scaleVal = scale.data("scale");
            } else {
              if ($(".fit-to-width").parent("div").hasClass("selected")) scaleVal = "w";
              else if ($(".fit-to-height").parent("div").hasClass("selected")) scaleVal = "h";
              else scaleVal = scale.find("input.pickFieldHidden").val();
            };

            j.npocomputer.modules.previewdoc.setScale(scaleVal);
            fitTo(context.selectedObj.scale);

            currFrame.css('visibility', 'visible');
          }

          // open external links in separate window.
          frameLoad(currFrame);
        }

      });

      // TODO: disabling allow-copy-text icon
      // open external links in separate window.
      frameLoad(currFrame);

      disableScreen(false);

      setFrameHeight(context);

      initSelectedVersion();

      // исправление замечания: http://directum.npo-comp.ru/reference.asp?sys=TEHKASNPO&compcode=%D0%97%D0%97%D0%9F&ID=4991248
      //j.npocomputer.modules.previewdoc.setScale("w");
    },

    selectVersion: function (key) {
      var me = this;
      var context = this.context || Core.preview.info;;
      disableScreen(true);
      var verId = key;

      context.errorMessage = false;

      j.ajax({
        type: "GET",
        url: context.previewHandlerUrl,
        data: { id: verId },
        cache: false,
        dataType: "json",
        success: function (data) {

          me.hideError();
          disableScreen(false);

          var currFrame = j("#" + context.wrapperId + ' #' + context.frameId);
          currFrame.show();

          context.selectedObj.id = verId;
          context.selectedObj.pageNumber = 1;
          context.convertedObj.id = data.Id;
          context.convertedObj.pageCount = data.PageCount;
          context.convertedObj.docExtension = data.DocExtension;
          context.convertedObj.isImage = data.IsImage;

          initSelectedVersion();
        },
        error: function (response) {

          me.hideError();
          disableScreen(false);

          var msg = JSON.parse(response.responseText);
          me.showError(msg.error, msg.errorType);

          var currFrame = j("#" + context.wrapperId + ' #' + context.frameId);
          currFrame.hide();

        }
      });
    },

    setScale: function (key) {
      var context = j.npocomputer.modules.previewdoc.context || Core.preview.info;
      context.selectedObj.scale = key;
      var frame = j("#" + context.wrapperId + " #" + context.frameId);
      var img = frame.contents().find('img');
      fitTo(key);

      if (!WAforPDA()) {
        Core.preview.scrolling.setScale(key);
      } {
        if (key != 'h' && key != 'w' && key != 'a') {
          img
          .height("auto")
          .width(img.attr('initWidth') * (key / 100));
        }

        if ($.scrollActive || WA.ENV.isAndroid()) {
          if (!WAforPDA()) RefreshScrollInIFrame();
        }
      }
    },

    showError: function (errorMsg, errorType) {
      var cont = j(".npocomputer-previewdoc-errors-place-holder");
      cont.find('.error_div_msg').hide();

      var errType = (errorType == 'error');
      ErrorShow(errorMsg, errType);
      cont.show();

      // Убираем padding со стандартной компоненты с ошибкой, т.к. в предпросмотре своя.
      j(".error_content_padding").removeClass('error_content_padding');
    },

    hideError: function () {
      j(".npocomputer-previewdoc-errors-place-holder").hide();
    },

    /**
    * Отключить показ исправлений
    * @function Core.preview.scrolling.toggleTrackChanges
    * @return {Core.preview.scrolling}
    * @since 5.1.3.1030
    */
    toggleTrackChanges: function () {
      var context = j.npocomputer.modules.previewdoc.context || Core.preview.info;

      var wrapper = j("#" + context.wrapperId);
      var button = wrapper.find(".enable-change-track");

      if (button.hasClass('selected')) {
        button.removeClass('selected');
        this.disableTrackChanges();
      } else {
        button.addClass('selected');
        this.enableTrackChanges();
      }

      // Сохранить настройку в профиле
      WA.SRV.call('Session.asmx/SetUserProfileSettings', { ParamName: 'DisableWordChangeTracking', ParamValue: +(!button.hasClass('selected')) });
    },
    enableTrackChanges: function () {
      // Нужно получать, т.к. вызывается при инициализации страницы
      var me = this;
      var context = j.npocomputer.modules.previewdoc.context || Core.preview.info;
      var wrapper = j("#" + context.wrapperId);
      var frameDoc = wrapper.find("#" + context.frameId).contents();

      frameDoc.find(wordDocumentSelector.insertedText)
          .css('color', 'teal')
          .css('text-decoration', 'underline');
      frameDoc.find(wordDocumentSelector.deletedText).show();

      // Показать скрытые примечания
      var commentButton = wrapper.find(".enable-comments");
      if (commentButton.hasClass('selected')) {
        var comments = frameDoc.find(wordDocumentSelector.comments);
        var areas = frameDoc.find(wordDocumentSelector.commentArea);
        if (comments.filter(':visible').length === 0) {
          me.enableComments();
        } else {
          comments.show();
          areas.show();
        }
      }
    },
    disableTrackChanges: function () {
      // Нужно получать, т.к. вызывается при инициализации страницы
      var me = this;
      var context = j.npocomputer.modules.previewdoc.context || Core.preview.info;
      var wrapper = j("#" + context.wrapperId);
      var frameDoc = wrapper.find("#" + context.frameId).contents();

      frameDoc.find(wordDocumentSelector.insertedText)
          .css('color', 'inherit')
          .css('text-decoration', 'none');
      frameDoc.find(wordDocumentSelector.deletedText).hide();

      // Если скрываем исправления, то нужно скрыть и соответствующие примечания
      var delCommentsSelectors = me.getDeletedCommentsSelector(frameDoc);
      var comments = frameDoc.find(delCommentsSelectors.comments);
      if (comments.length === frameDoc.find(wordDocumentSelector.comments).length) {
        me.disableComments();
      } else {
        comments.hide();
        frameDoc.find(delCommentsSelectors.anchors).hide();
        frameDoc.find(delCommentsSelectors.areas).hide();
      }

    },

    /**
    * Отключить показ примечаний
    * @function Core.preview.scrolling.toggleTrackChanges
    * @return {Core.preview.scrolling}
    * @since 5.1.3.1031
    */
    toggleComments: function () {
      var context = j.npocomputer.modules.previewdoc.context || Core.preview.info;

      var wrapper = j("#" + context.wrapperId);
      var button = wrapper.find(".enable-comments");

      if (button.hasClass('selected')) {
        this.disableComments();
        button.removeClass('selected');
      } else {
        this.enableComments();
        button.addClass('selected');
      }

      // Сохранить настройку в профиле
      WA.SRV.call('Session.asmx/SetUserProfileSettings', { ParamName: 'DisableWordComments', ParamValue: +(!button.hasClass('selected')) });
    },
    enableComments: function () {
      // Нужно получать, т.к. вызывается при инициализации страницы
      var me = this;
      var context = j.npocomputer.modules.previewdoc.context || Core.preview.info;
      var wrapper = j("#" + context.wrapperId);
      var frameDoc = wrapper.find("#" + context.frameId).contents();
      var buttonTrack = wrapper.find(".enable-change-track");

      var reviewBlockWidth = frameDoc.find('#review').width();
      var docContainer = frameDoc.find('div[class*=WordSection]');
      var oldMarginStr = docContainer.css('margin-left') || "0px";
      var newMargin = parseInt(oldMarginStr.replace('px', '')) - Math.round(reviewBlockWidth / 2.0);

      var comments = frameDoc.find(wordDocumentSelector.comments);

      // Исключить примечания к исправлениям, если отключен их показ
      if (!buttonTrack.hasClass('selected')) {
        comments = comments.not(me.getDeletedCommentsSelector(frameDoc).comments);
      }
      if (comments.length > 0) {
        frameDoc.find(wordDocumentSelector.commentAnchors).show();
        comments.show();
        frameDoc.find('#review').show();
        docContainer.css('margin-left', newMargin + 'px');
        Core.preview.alignComments(frameDoc.find(wordDocumentSelector.commentAnchors));
      }
    },
    disableComments: function () {
      // Нужно получать, т.к. вызывается при инициализации страницы
      var context = j.npocomputer.modules.previewdoc.context || Core.preview.info;
      var wrapper = j("#" + context.wrapperId);
      var frameDoc = wrapper.find("#" + context.frameId).contents();

      var reviewBlockWidth = frameDoc.find('#review').width();
      var docContainer = frameDoc.find('div[class*=WordSection]');
      var oldMarginStr = docContainer.css('margin-left') || "0px";
      var newMargin = parseInt(oldMarginStr.replace('px', '')) + Math.round(reviewBlockWidth / 2.0);

      var comments = frameDoc.find(wordDocumentSelector.comments + ':visible');
      if (comments.length > 0) {
        comments.hide();
        frameDoc.find(wordDocumentSelector.commentAnchors).hide();
        frameDoc.find('#review').hide();
        docContainer.css('margin-left', newMargin + 'px');
      }
    },

    getCommentIdByAnchorName: function (href) {
      return href.replace('#_mso', '_');
    },

    getDeletedCommentsSelector: function (container) {
      var commentAreas = container.find(wordDocumentSelector.commentArea);
      // Ищем текст комментариев, в котором находится только del-элемент.
      commentAreas = _.filter(commentAreas, function (el) { return el.children.length === 1 && j(el).find('del').length > 0; });

      var commentSelectors = {};

      var comments = j.map(commentAreas, function (el) { return '#' + el.name.replace('ref', ''); });
      commentSelectors.areas = j.map(commentAreas, function (el) { return 'a[name=' + el.name + ']' }).join(',');
      commentSelectors.anchors = j.map(comments, function (el) { return wordDocumentSelector.commentAnchors + '[href=' + el + ']' }).join(',');
      commentSelectors.comments = comments.join(',');

      return commentSelectors;
    }
  };

})(jQuery, window);
